import { NavigateFunction } from 'react-router'

import { ErrorCode } from '../Error/OpenBankingErrorPage'
import {
  setCurrentPlaidToken,
  storeSuccessfulBankConnection,
} from '../post-quote/features/payments/ConnectYourBank/OpenPlaidButton'
import { makeApiCall } from '../post-quote/features/payments/Payment/PaymentForm/fetchConfig'

import { report } from 'utils'

export const submitAccountDataAndContinueToPayment = (
  navigate: NavigateFunction,
  quoteId: string,
  plan: string,
  publicToken: string,
  redirectWithErrorCode: (errorCode: ErrorCode) => void,
) => {
  const paymentPlan = plan.toLowerCase()
  const endpoint = `/quoting/quotes/${quoteId}/open-banking-connections`
  const payload = {
    publicToken,
  }

  makeApiCall({
    path: endpoint,
    body: payload,
    method: 'POST',
  })
    .then((response) => {
      // Accepted – Customer has a current account
      if (response.status === 202) {
        setCurrentPlaidToken(publicToken)
        storeSuccessfulBankConnection(false)
        navigate(`/quote/${quoteId}/payment/${paymentPlan}`)

        return
      }

      // Likely that the customer started the session on another browser and their banking app redirected them to their default browser
      // Happens frequently on iOS
      if (response.status === 403) {
        redirectWithErrorCode('open_banking_session_expired')
        return
      }

      // Error - General error has occurred
      if (response.status > 300 || response.status < 200) {
        redirectWithErrorCode('open_banking_backend_error')

        return
      }

      response.json().then((json) => {
        // Rejected – Customer does not have a current account
        if (response.status === 202 && json.code && json.code.includes('OB1')) {
          redirectWithErrorCode('wrong_account_ob1')

          return
        }
      })
    })
    .catch((error) => {
      report(error, error.message)
      redirectWithErrorCode('submit_account_data_frontend_error')
    })
}
